createLocation